import { ApiResponse } from '@/types/api.types';
import { Profile, CreateProfileDto } from '@/types/profile.types';
import { BaseApiService } from './base.service';
import { AxiosInstance } from 'axios';

export class ProfileService extends BaseApiService {
    private readonly baseUrl = '/v1/profiles';

    constructor(axiosInstance: AxiosInstance) {
        super(axiosInstance);
    }

    async getProfiles(): Promise<ApiResponse<Profile[]>> {
        return this.get<Profile[]>(this.baseUrl);
    }

    async getDefaultProfile(): Promise<ApiResponse<Profile>> {
        return this.get<Profile>(`${this.baseUrl}/default`);
    }

    async getProfileById(id: string): Promise<ApiResponse<Profile>> {
        return this.get<Profile>(`${this.baseUrl}/${id}`);
    }

    async createProfile(profileData: CreateProfileDto): Promise<ApiResponse<Profile>> {
        return this.post<Profile>(this.baseUrl, profileData);
    }

    async updateProfile(id: string, profileData: Partial<CreateProfileDto>): Promise<ApiResponse<Profile>> {
        return this.patch<Profile>(`${this.baseUrl}/${id}`, profileData);
    }

    async deleteProfile(id: string): Promise<ApiResponse<void>> {
        return this.delete(`${this.baseUrl}/${id}`);
    }
}